import React, { useState } from "react";

export type FloatingEmergencyButtonProps = {
  onClick?: () => void; // optional custom handler
  variant?: "floating" | "navbar";
};

export default function FloatingEmergencyButton({
  onClick,
  variant = "floating",
}: FloatingEmergencyButtonProps) {
  const [pulsing, setPulsing] = useState(false);

  const defaultAlert = () => {
    alert(
      "🚨 Emergency Protocol Activated!\n\nAll relevant authorities have been notified.\nEmergency response team dispatched."
    );
  };

  const handleClick = () => {
    // prefer custom handler if provided; otherwise show default alert
    if (onClick) onClick();
    else defaultAlert();

    setPulsing(true);
    window.setTimeout(() => setPulsing(false), 4000);
  };

  const buttonClasses =
    variant === "navbar"
      ? `inline-flex h-10 w-10 items-center justify-center rounded-full bg-red-600 text-white shadow-lg transition-transform duration-200 hover:scale-105 hover:bg-red-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-red-200 ${
          pulsing ? "status-indicator" : ""
        }`
      : `w-16 h-16 bg-red-600 hover:bg-red-700 text-white rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center ${
          pulsing ? "status-indicator" : ""
        }`;

  const iconClasses = variant === "navbar" ? "w-5 h-5" : "w-8 h-8";

  const button = (
    <button
      type="button"
      onClick={handleClick}
      className={buttonClasses}
      aria-label="Emergency"
    >
      <svg className={iconClasses} fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  );

  if (variant === "navbar") {
    return button;
  }

  return <div className="floating-widget">{button}</div>;
}
